
import { ref, onMounted, onUnmounted } from 'vue';


export function useViewport(format) {
    const viewport = ref('');
    const viewportSize = {
        xxxSmall: 375,
        xxSmall: 400,
        xSmall: 600,
        small: 905,
        medium: 1240,
        large: 1440
    }

    const handleResize = () => {
        viewport.value = window.innerWidth <= viewportSize.xxxSmall ? 'xxxSmall' :
            window.innerWidth <= viewportSize.xxSmall ? 'xxSmall' :
                window.innerWidth <= viewportSize.xSmall ? 'xSmall' :
                    window.innerWidth <= viewportSize.small ? 'small' :
                        window.innerWidth <= viewportSize.medium ? 'medium' :
                            window.innerWidth <= viewportSize.large ? 'large' : 'xLarge';
    }


    onMounted(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
    });

    onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
    })

    return {
        viewport
    };
}